import { NgModule } from '@angular/core';
import { MatAutocompleteModule } from '@angular/material';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { RouterModule, Routes } from '@angular/router';
import { HorizontalBarChartModule } from '@core/components/charts/horizontal-bar/horizontal-bar.module';
import { PieChartModule } from '@core/components/charts/pie/pie.module';
import { VerticalBarChartModule } from '@core/components/charts/vertical-bar/vertical-bar.module';
import { DataCardModule } from '@core/components/data-card/data-card.module';
import { FcDataCardModule } from '@core/components/fc-data-card/fc-data-card.module';
import { FcDateInputModule } from '@core/components/fc-input/base/fc-date-input/fc-date-input.module';
import { FcCompaniesInputModule } from '@core/components/fc-input/search-many/fc-companies-input/fc-companies-input.module';
import { FcLocationGroupsInputModule } from '@core/components/fc-input/search-many/fc-location-groups-input/fc-location-groups-input.module';
import { FcLocationsInputModule } from '@core/components/fc-input/search-many/fc-locations-input/fc-locations-input.module';
import { FcMaintenanceTypesInputModule } from '@core/components/fc-input/search-many/fc-maintenance-types-input/fc-maintenance-types-input.module';
import { FcSegmentsInputModule } from '@core/components/fc-input/search-many/fc-segments-input/fc-segments-input.module';
import { CompaniesComponentModule } from '@core/components/inputs/companies/companies.module';
import { LocationsGroupsComponentModule } from '@core/components/inputs/locations-groups/locations-groups.module';
import { LocationsComponentModule } from '@core/components/inputs/locations/locations.module';
import { MaintenanceTypeModule } from '@core/components/inputs/maintenance-type/maintenance-type.module';
import { SegmentsModule } from '@core/components/inputs/segments/segments.module';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { FilterModule } from '../components/filter/filters.module';
import { ReportFilterApi } from '../components/filter/services/report-filter-api.service';
import { DashboardMaintenancesComponent } from './dashboard-maintenances.component';
import { DashboardMaintenancesService } from './services/dashboard-maintenances.service';

const routes: Routes = [
  {
    path: 'relatorios/manutencoes',
    component: DashboardMaintenancesComponent,
    canActivate: [AuthenticatedGuard],
    data: { title: 'CORE.SERVICES.NAVIGATION.REPORTS.MAINTENANCES' }
  }
];

@NgModule({
  declarations: [
    DashboardMaintenancesComponent
  ],
  imports: [
    RouterModule.forChild(routes),
    TranslateModule,
    FuseSharedModule,
    FuseSidebarModule,
    FuseWidgetModule,
    MatIconModule,
    MatTabsModule,
    MatButtonModule,
    MatTooltipModule,
    MatSelectModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatSlideToggleModule,
    DataCardModule,
    FcDataCardModule,
    PieChartModule,
    HorizontalBarChartModule,
    VerticalBarChartModule,
    LocationsComponentModule,
    MaintenanceTypeModule,
    CompaniesComponentModule,
    LocationsGroupsComponentModule,
    SegmentsModule,
    FilterModule,
    FcLocationsInputModule,
    FcMaintenanceTypesInputModule,
    FcSegmentsInputModule,
    FcLocationGroupsInputModule,
    FcCompaniesInputModule,
    FcDateInputModule,
    MatAutocompleteModule,
  ],
  exports: [
    DashboardMaintenancesComponent
  ],
  providers: [
    DashboardMaintenancesService,
    ReportFilterApi
  ]
})

export class DashboardMaintenancesModule {}
